import { IAffectedOrder, ICoverageGap, ICoverageSummary, IDemandCoverageSummary } from "../interfaces/coverage";

export const listUncoveredDestinationGaps = (summary: ICoverageSummary): ICoverageGap[] =>
  summary.gaps.filter((gap) => gap.type === "destination_not_covered");

export const listWeightGaps = (summary: ICoverageSummary): ICoverageGap[] =>
  summary.gaps.filter((gap) => gap.type === "weight_gap");

export const calculateMatrixCompletionRate = (summary: ICoverageSummary): number | null => {
  const totalUnits = summary.validRowCount + summary.gaps.length;
  if (totalUnits === 0) return null;
  return (summary.validRowCount / totalUnits) * 100;
};

export const listAffectedOrders = (summary: IDemandCoverageSummary): IAffectedOrder[] =>
  summary.gaps.flatMap((gap) => gap.orders);
